import axios from "../../Axios";
import { Urls } from "../../Urls";

/**
 * Maps the UI tab/type to the backend bucket name.
 */
export const mapBucketValue = (type) => {
  switch (type) {
    case "expired_enquiries":
      return "expired";
    case "cancelled":
      return "cancelled";
    case "approved":
      return "approved";
    case "all":
      return "all";
    default:
      return "active";
  }
};

/**
 * Builds the payload for fetching enquiries in a specific bucket.
 */
export const buildBucketFilterPayload = ({ currentFilterPayload, initialPayload, bucketValue, visibleEnquiry }) => {
  return {
    ...(currentFilterPayload || initialPayload || {}),
    bucket: bucketValue,
    pagination: { skip: 0, limit: visibleEnquiry || 10 },
  };
};

/**
 * Processes chat unread counts into the enquiry list.
 * Extracted from NewEnquiry.reload_data().
 */
export const processChatMessagesIntoEnquiries = (enquiries, chatMessages) => {
  return enquiries.map((el) => {
    const msg = chatMessages.find((m) => m.truck_enquiry_id === el.truck_enquiry_id);
    return {
      ...el,
      viewmessage: msg ? msg.transporter_unread_count : el.viewmessage,
      disabled: true,
    };
  });
};
